import ReactDOM from "react-dom/client";
import App from "./App";
import "antd/dist/antd.min.css";
import "react-toastify/dist/ReactToastify.min.css";
import { ConfigProvider } from "antd";
import tr_TR from "antd/es/locale/tr_TR";
import "moment/locale/tr";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ConfigProvider locale={tr_TR}>
    <App />
  </ConfigProvider>
);
